import { render, staticRenderFns } from "./listareserva.vue?vue&type=template&id=fd412fde&scoped=true&"
import script from "./listareserva.vue?vue&type=script&lang=js&"
export * from "./listareserva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd412fde",
  null
  
)

export default component.exports